module.exports = __webpack_public_path__ + "img/ic_cancle_circle_input.fa84d709.svg";